import { get } from 'lodash';

const styles = (theme) => ({
  proxyUrlContainer: {
    color: get(theme, 'color.orange'),
  },
  actionButtonsContainer : {
    display : 'flex',
  },
  editButton: {
    textTransform: 'none',
    color: get(theme, 'color.primaryButtonText'),
    backgroundColor: get(theme, 'color.primaryButtonBackground'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
    width: "50px",
    height : "30px !important",
  },
  deleteButton: {
    textTransform: 'none',
    color: get(theme, 'color.primaryButtonBackground'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
    width: "80px",
    marginLeft : "0.5rem",
    height : "30px !important",
  },
  proxyNameContainer : {
    color: get(theme, 'color.link'),
    fontWeight: "bold",
    cursor : "pointer",
  },
  proxyConnectionStatusContainer : {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  keyStoreNameContainer : {
    color: get(theme, 'color.link'),
    fontWeight: "bold",
    cursor : "pointer",
  },
  connectionStatusIcon : {
    fontSize: 14,
  },
  filtersContainer: {
    alignItems: "end",
  },
  selectFieldContainer: {
    margin: `${get(theme.margin, 'm0')} !important`,
    paddingBottom: 7,
  },
  fieldContainer: {
    margin: `${get(theme.margin, 'm0')} !important`,
    marginRight: '5px !important',
  },
})
export default styles;